
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";


const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC6bdDlfMOk99te_Am0VwBHjpKE-TSOYHg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "portfolio-b4af2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "portfolio-b4af2",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "portfolio-b4af2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "146751225752",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:146751225752:web:09b35a33e6d5e7667975ed",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-Q1QG9LSKXY"
};


if (useEmulators) {
  if (typeof window !== 'undefined' && !['localhost', '127.0.0.1', '::1', '[::1]'].includes(window.location.hostname)) throw new Error('Emulator mode is available only on localhost.');
  firebaseConfig.projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'demo-soaplab';
  if (!firebaseConfig.projectId.startsWith('demo-')) throw new Error('Use a demo- Firebase project for local emulator testing.');
  firebaseConfig.apiKey = 'demo-api-key';
  firebaseConfig.authDomain = 'localhost';
  firebaseConfig.storageBucket = `${firebaseConfig.projectId}.appspot.com`;
}
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Export functions instance - use us-central1 (default region where functions are deployed)
export const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1');

if (useEmulators) {
  const host = process.env.REACT_APP_EMULATOR_HOST || '127.0.0.1';
  connectFirestoreEmulator(db, host, Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
  connectAuthEmulator(auth, `http://${host}:${process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099}`, { disableWarnings: true });
  connectStorageEmulator(storage, host, Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199));
  connectFunctionsEmulator(functions, host, Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001));
}

